import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShoppingCartCheckoutIcon(props: IconProps) {
    return <Icon {...props} iconKey={"shopping_cart_checkout"}/>
}
